import useFeatures from 'hooks/useFeatures';
import { Navigate } from 'react-router-dom';
import IntegrationsTabs from './IntegrationsTabs';
import useIntegrationsErrorCode from './hooks/useIntegrationsErrorCode';

const Integrations = () => {
  const { allowIntegrationsV3 } = useFeatures();

  useIntegrationsErrorCode();

  if (!allowIntegrationsV3) {
    return <Navigate to="/integrations-migrated" />;
  }

  return (
    <div className="container">
      <IntegrationsTabs />
    </div>
  );
};

export default Integrations;
